module.exports = __webpack_public_path__ + "static/media/linkedIn.37762aff.svg";